import {
  useMutation,
  UseMutationResult,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from "@tanstack/react-query";
import { logException } from "@punchup/sentry";
import {
  addVideosToPodcast,
  getComedianManagerPodcasts,
} from "../../client/manager/podcasts";
import { Podcast } from "../../models/podcasts";

export const managerPodcastsQueryKey = (comedianId: string) =>
  ["managerPodcasts", comedianId] as const;

export function useManagerPodcasts(
  comedianId: string,
  options?: { enabled?: boolean }
): UseQueryResult<Podcast[], Error> {
  return useQuery({
    queryKey: managerPodcastsQueryKey(comedianId),
    queryFn: () => getComedianManagerPodcasts(comedianId),
    enabled: !!comedianId && options?.enabled !== false,
    staleTime: 60_000,
  });
}

export function useAddVideosToPodcast(
  comedianId: string
): UseMutationResult<void, Error, { podcastId: string; specialIds: string[] }> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      podcastId,
      specialIds,
    }: {
      podcastId: string;
      specialIds: string[];
    }) => addVideosToPodcast(podcastId, specialIds),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: managerPodcastsQueryKey(comedianId),
      });
    },
    onError: (err) => {
      logException(err, {
        data: "[useAddVideosToPodcast] Failed to add videos to podcast",
      });
    },
  });
}
